// Cross-game progress helpers: which labs domain tests a player has finished.
//
// Each game marks its own completion under a per-domain localStorage key when the player
// finishes the full test (24 uses a legacy key predating the `labs_test_complete_{domain}`
// convention). This is the state the unlock ladder is built on; for now it drives one thing —
// the adaptive warm-up auto-skips for anyone who has already completed ANY labs game, since
// the think-aloud-commit gesture is identical across domains and only needs teaching once.

// All known per-domain completion keys (legacy 24 key included).
export const LABS_TEST_KEYS = ['labs24_test_complete', 'labs_test_complete_rebus', 'labs_test_complete_cryptic'] as const

// True if the player has completed the full test in ANY labs domain.
export const hasCompletedAnyLabsTest = (): boolean => {
  try {
    return LABS_TEST_KEYS.some((k) => localStorage.getItem(k) === '1')
  } catch {
    return false
  }
}

// Research consent is a SINGLE consent covering all labs games (same voice→text data, same
// purpose), so we ask once per device and skip it on return — including across visits to /labs and
// across game switches. A consent record is still written for every session (each game's handleStart
// calls saveConsent), so the ethics/join trail is intact; this flag only governs the UI prompt.
const CONSENT_KEY = 'labs_consented_v1'
export const hasConsented = (): boolean => {
  try {
    return localStorage.getItem(CONSENT_KEY) === '1'
  } catch {
    return false
  }
}
export const markConsented = (): void => {
  try {
    localStorage.setItem(CONSENT_KEY, '1')
  } catch {
    /* noop */
  }
}
